import { toast } from "react-hot-toast";
import { Card } from "../Card";
import CheckIcon from "../../../assets/images/toastCheck.svg";
import CrossIcon from "../../../assets/images/toastClose.svg";
import ExclaimanationIcon from "../../../assets/images/toastExclaim.svg";

export const showCustomToast = (
    type: "success" | "error" | "warning",
    message: string
) => {
    const iconMap = {
        success: <img src={CheckIcon} alt="CheckIcon" />,
        error: <img src={CrossIcon} alt="CrossIcon" />,
        warning: <img src={ExclaimanationIcon} alt="ExclaimanationIcon" />,
    };

    toast.custom(
        (t) => (
            <Card
                innerClassName="flex items-center justify-between p-5"
                padding="none"
                className={`max-w-[400px] bg-modalBg border-dropdownBorder w-full ${
                    t.visible ? "animate-enter" : "animate-leave"
                }`}
            >
                <p className="text-sm font-normal text-white">{message}</p>
                <div className="w-5 h-5 rounded-full flex items-center justify-center">
                    {iconMap[type]}
                </div>
            </Card>
        ),
        {
            duration: 3000,
        }
    );
};
